<!-- 客服中心 -->
<template lang="">
<div style="height:calc(100% - 30px);margin-top: 20px;">
    <el-card class="box-card" style="height: 100%" :body-style="{height: 'calc(100% - 100px)',overflow: 'auto'}">
        <div slot="header">客服中心 ></div>
        <div>
            <el-form v-if="JSON.stringify(formData)!='{}'" ref="formAuth" :model="formData" label-width="200px" :show-message="false" :status-icon="true" size="small">
                <div style="padding-bottom:50px"></div>
                <el-form-item label="客服电话：" prop="service_ke_fu" required>
                    <el-input v-model="formData['service_ke_fu'].value" type="number" autocomplete="off" size="small" placeholder="请输入" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="投诉电话：" prop="service_tou_su" required>
                    <el-input v-model="formData['service_tou_su'].value" type="number" autocomplete="off" size="small" placeholder="请输入" style="width:300px"></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" size="small" style="margin:150px auto 0;display: block;width:100%" @click="handleSubmit()">确定</el-button>
        </div>
    </el-card>
</div>
</template>

<script>
export default {
    data() {
        return {
            formData: {},
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.http.post('/admin/SystemConfig/indexByClass', { class: 'service' }).then(re => {
                this.formData = re;
            })
        },
        handleSubmit() {
            this.$refs['formAuth'].validate((valid) => {
                if(valid) {
                    this.http.post('/admin/SystemConfig/save', this.formData).then(() => {
                        this.$message.success('操作成功');
                        this.getData()
                    });
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.tip {
    padding-left: 30px;
    color: #8F959E;
}
</style>
